<template>
  <template v-if="isShowComponent()">
    <div class="card" id="post-faq">
      <div class="card-header">
        <h3 class="card-title title">Вопрос-ответ</h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="mb-3">
            <PageBuilder :payload="{
              val: fields.val,
            }" @onUpdate="onUpdate"/>
          </div>
        </div>
      </div>
    </div>
  </template>

  <template v-if="!isReadyPage()">
    <div class="text-center p-1">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </template>
</template>

<script>
import "./css/style.css"
import {defineComponent, onMounted, reactive, ref, toRaw} from "vue"
import element from "@/modules/post/components/composites/services/element"
import PageBuilder from "./components/page_builder/Index"

export default defineComponent({
  name: "Faq",
  components: {
    PageBuilder,
  },
  props: {
    data: {
      type: Object,
      required: true
    },
  },
  setup(props, {emit}) {
    let readyPage = ref(false)
    const fields = reactive(getFields())

    function getFields() {
      return {
        val: [],
      }
    }

    function setFields(item) {
      fields.val = item?.val ?? JSON.parse('[]')
    }

    onMounted(() => {
      setFields({
        val: props.data?.val ?? [],
      })
      readyPageOn()
    })

    function isShowComponent() {
      return isReadyPage()
    }

    function isReadyPage() {
      return readyPage.value === true
    }

    function readyPageOn() {
      readyPage.value = true
    }

    function onUpdate(val) {
      emit('onUpdate', toRaw(val))
    }

    return {
      element,
      isShowComponent,
      isReadyPage,
      onUpdate,
      fields,
    }
  }
})
</script>

<style scoped>
#post-faq .title {
  font-size: 0.9rem;
}
</style>
